var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 34"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "#B42318",
    rx: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m24 12-.867 12.142A2 2 0 0 1 21.138 26h-8.276a2 2 0 0 1-1.995-1.858L10 12m5 4v6m4-6v6m1-10V9a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v3m-5 0h16"
  })));
};
export default SvgDelete;